import { Component, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ValidationService } from "src/app/services/validation.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "src/environments/environment";
import * as Constants from "../../../../../constant/Constants";
import { ApiCallService } from "src/app/api/service/api-call.service";
import { ConfirmComponent } from "src/app/components/dialog/confirm/confirm.component";
import { IConfirmDialogData } from "src/app/components/dialog/dialog.data";

@Component({
  selector: "app-page3",
  templateUrl: "./page3.component.html",
  styleUrls: ["./page3.component.css"],
})
export class Page3Component implements OnInit {
  // Url Params
  claim: string = "own"; // own, flood, fire ... etc.
  id: string = "none";
  token: string = "placeholder-value"; // to validate the public accesses.
  // +++++++++++

  genericDialogData: IConfirmDialogData = {
    title: '',
    content: '',
    cancelButtonText: '',
    confirmButtonText: ''
  };

  pageHeading: string = "Claim Form";
  pageHeadingSuffix: string = " Claim Form (Continued)";
  pageSubheading: string = "Enter Damage Details";

  damageInfoLabel: string = "State briefly the apparent damage to the car";
  othersDamagedQuestion: string =
    "Were other vehicles involved and property damaged?";

  yesText: string = "Yes";
  noText: string = "No";

  ownerNameLabel: string = "Enter name of owner";
  ownerAddressLabel: string = "Enter address of owner";
  insurerNameLabel: string = "Name of insurer";
  policyNumLabel: string = "Policy Number";
  otherDriverNameLabel: string = "Enter name of other driver";
  otherDriverNumLabel: string = "Enter phone number of other driver";
  otherPropertyDamagedLabel: string = "Other property damaged";

  addmoreCarsLabel: string = "Add more cars involved";
  dateLabel: string = "Date";

  cancelText: string = "Cancel";
  saveText: string = "Save and Continue";

  requiredString: string = "This field is required";
  remove: string = 'Remove';

  motorForm = this._formBuilder.group({
    damageInfo: ["", Validators.required],
    othersDamaged: this._formBuilder.group({
      yes: false,
      no: true,
    }),
    extra: this._formBuilder.array([]),
  });

  formGroupErrors: { [key: string]: string } = {
    othersDamaged: "",
  };

  formErrors: { [key: string]: string } = {
    damageInfo: "",
    ownerName: "",
    ownerAddress: "",
    insurerName: "",
    policyNum: "",
    otherDriverName: "",
    otherDriverNum: "",
    otherPropertyDamaged: "",
  };

  validationMessages: { [key: string]: { [key: string]: string } } = {
    damageInfo: { required: this.requiredString },
    ownerName: { required: this.requiredString },
    ownerAddress: { required: this.requiredString },
    insurerName: { required: this.requiredString },
    policyNum: { required: this.requiredString },
    otherDriverName: { required: this.requiredString },
    otherDriverNum: { required: this.requiredString },
    otherPropertyDamaged: { required: this.requiredString },
    othersDamaged: { required: this.requiredString },
  };

  constructor(
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private validationService: ValidationService,
    public dialog: MatDialog,
    private apiCallService: ApiCallService,
  ) {}

  url: string = environment.baseUrl + Constants.claimExtraDetailsURL;

  loading: boolean = false;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.token = params["token"] !== 'undefined' ? params["token"] : Constants.tokenPlaceholderValue;

      if (params["id"] !== undefined) {
        this.id = params["id"];
      }
      if (params["claim"] !== undefined) {
        this.claim = params["claim"];

        if (params["claim"] === "fire") {
          this.pageHeading = "Fire Damage" + this.pageHeadingSuffix;
        } else if (params["claim"] === "flood") {
          this.pageHeading = "Flood Damage" + this.pageHeadingSuffix;
        } else if (params["claim"] === "own") {
          this.pageHeading = "Own Damage/Car Damage" + this.pageHeadingSuffix;
        }
      }
    });

    this.motorForm.valueChanges.subscribe((form) => {
      this.logErrors();
    });
    
    this.validationService.subcribeToControlChanges(
      "othersDamaged",
      this.motorForm,
      this.formGroupErrors,
      this.validationMessages
    );
  }

  createExtraFormGroup(): FormGroup {
    return this._formBuilder.group({
      ownerName: [""],
      ownerAddress: [""],
      insurerName: [""],
      policyNum: [""],
      otherDriverName: [""],
      otherDriverNum: [""],
      otherPropertyDamaged: ["", Validators.required],
    });
  };

  addNewEntry() {
    const fields = this.motorForm.get('extra') as FormArray;
    fields.push(this.createExtraFormGroup());
    this.motorForm.setControl('extra', fields);
  }

  removeEntry(i:number) {
    const fields = this.motorForm.get('extra') as FormArray;
    fields.removeAt(i);  
  }

  getEntries() : FormArray {  
    return this.motorForm.get("extra") as FormArray  
  }

  logErrors() {
    this.validationService.logValidationErrors(
      this.motorForm,
      this.formErrors,
      this.validationMessages
    );
  }
  onYesChange() {
    if (this.getEntries().length === 0) {
      this.addNewEntry();
    }
    this.motorForm.controls["othersDamaged"].controls["no"].setValue(false);
  }

  onNoChange() {
    if (this.getEntries().length > 0) {
      for (let i = 0; i < this.getEntries().length; i++) {
        this.removeEntry(i);
      }
    }
    
    this.motorForm.controls["othersDamaged"].controls["yes"].setValue(false);
  }

  initDialogData(title: string, content: string, cancelButtonText: string, confirmButtonText: string) {
    this.genericDialogData.title = title;
    this.genericDialogData.content = content;
    this.genericDialogData.cancelButtonText = cancelButtonText;
    this.genericDialogData.confirmButtonText = confirmButtonText;
  };

  showGenericPopup(runFunction: ()=> void) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      disableClose: true,
      data: this.genericDialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.group('Generic Dialog');
      if (result) {
        console.log('dialog confirmed');
        runFunction();
      } else {
        console.log('dialog dismissed');
      }
      console.groupEnd();
    });
  };

  postDataToWhatsapp = async () => {
    this.loading = true;

    const req = {
      page: 'claimData3',
      damageInfo: this.motorForm.controls["damageInfo"].value,
      isMoreCarsInv: this.motorForm.controls["othersDamaged"].controls["yes"].value === true ? 'Yes' : 'no',
      extraPeople: this.motorForm.controls["extra"].value,
      // ownerName: this.motorForm.controls["othersDamaged"].controls["yes"].value === true ? this.motorForm.controls["ownerName"].value : null,
      // ownerAddress: this.motorForm.controls["othersDamaged"].controls["yes"].value === true ? this.motorForm.controls["ownerAddress"].value : null,
      // insurerName: this.motorForm.controls["othersDamaged"].controls["yes"].value === true ? this.motorForm.controls["insurerName"].value : null,
      // policyNum: this.motorForm.controls["othersDamaged"].controls["yes"].value === true ? this.motorForm.controls["policyNum"].value : null,
      // otherDriverName: this.motorForm.controls["othersDamaged"].controls["yes"].value === true ? this.motorForm.controls["otherDriverName"].value : null,
      // otherDriverNum: this.motorForm.controls["othersDamaged"].controls["yes"].value === true ? this.motorForm.controls["otherDriverNum"].value : null,
      // otherPropertyDamaged: this.motorForm.controls["othersDamaged"].controls["yes"].value === true ? this.motorForm.controls["otherPropertyDamaged"].value : null,
      token: this.token,
      filled: true,
    };

    try {
      // Update form data (POST)
      const response = await this.apiCallService.postRequest(
        `${this.url}?token=${this.token}`, req
      ); // url to change for UG?
      
      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Post successful :::");
        const nextToken = response.token;
        const nextPage = `/claim-details/page4`;
        // Navigate to Page 4 of claims Form
        this.router.navigate([nextPage], {queryParams: {claim: this.claim, id: this.id, token: nextToken}});
      } else {
        console.log("::: Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Submission Failed',
          'An error occurred while saving the form details',
          'cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.postDataToWhatsapp);
      }
    } catch (error) {
      console.log('ERROR :: ', error)
      this.loading = false;

      this.initDialogData(
        'Submission Failed',
        'An unexpected error occurred',
        'cancel',
        'TRY AGAIN'
      );
      this.showGenericPopup(this.postDataToWhatsapp);
    }
  }

  submitForm(): void {
    this.initDialogData(
      'Confirm submission',
      'Please proceed only if you have verified that the form details are correct',
      'Back',
      'Proceed'
    );

    this.showGenericPopup(this.postDataToWhatsapp);
  }

  confirmCancel() {
    this.initDialogData(
      'Warning',
      'Are you sure you want to cancel the application?',
      'back',
      'Cancel application'
    );

    this.showGenericPopup(this.cancelApplication);
  }

  cancelApplication = async () =>  {
    console.log("Cancelling application ...");
    // Update session that form application was cancelled
    this.loading = true;

    const req = {
      // User cancelled
      token: this.token,
      filled: false,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);

      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Cancel Post successful :::");
        // Navigate back to Whatsapp chat
        window.location.href = environment.whatsappRedirectURL;
        
      } else {
        console.log("::: Cancel Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          'Failed',
          'An error occurred while attempting to cancel your application',
          'Cancel',
          'TRY AGAIN'
        );

        this.showGenericPopup(this.cancelApplication);
      }
    } catch (error) {
      console.log('ERROR :: ', error);
      this.loading = false;

      // Navigate back to Whatsapp chat
      window.location.href = environment.whatsappRedirectURL;
    }
  }
}
